import en_US from '../locales/en_US'
import ja_JP from '../locales/ja_JP'
import zh_CN from '../locales/zh_CN'
import ko_KR from '../locales/ko_KR'

class LocalizationData {
  static getMessagesData = (locale) => {
    switch (locale) {
      case 'en':    return en_US
      case 'ja':    return ja_JP
      case 'zh-cn': return zh_CN
      case 'ko':    return ko_KR
      default:      return en_US
    }
  }
}

export default LocalizationData
